import styled from '@emotion/styled';
import { Stack, Flex } from '@pairy/pds-react';

import { Z_INDEX } from '@/constants/zIndex';

export const Wrapper = styled.div`
  position: absolute;
  z-index: ${Z_INDEX.loading};
  top: 0;
  left: 0;
  overflow: none;
  width: 100%;
  height: 100%;
`;

export const StackInnerWrapper = styled(Stack)`
  height: 100%;
`;

export const FlexTipWrapper = styled(Flex)`
  flex: 1;
  margin-bottom: 16px;
`;

export const StackTipInnerWrapper = styled(Stack)`
  width: auto;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.skyblue_200};
  margin-top: 40px;
  background-color: ${({ theme }) => theme.colors.skyblue_50};
  border-radius: 8px;
`;
